import theme, { TMaterialStyles } from '../../theme';

export const materialStyles: TMaterialStyles = {
  container: {
    height: '100vh',
    width: '100%',
    position: 'relative',
  },
  toggleViewButtons: {
    width: '100%',
    position: 'absolute',
    paddingTop: '20px',
    paddingBottom: '20px',
    zIndex: 10,
    bottom: 0,
  },
  topButtons: {
    width: '100%',
    position: 'absolute',
    zIndex: 10,
    top: '0',
    padding: '20px',
    backgroundColor: '#4141418a',
    display: 'flex',
    background: 'transparent',
    justifyContent: 'flex-end',
  },
  backBtn: {
    position: 'absolute',
    zIndex: 3000,
    top: '20px',
    left: '20px',
  },
  topButtonsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  attempts: {
    background: '#ffffffc9',
    padding: '5px',
    mr: 2,
    color: theme.palette.primary.main,
  },
  timerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: '31px',
    position: 'absolute',
    zIndex: 100,
    left: '50%',
    transform: 'translateX(-50%)',
  },
  attemptsContainer: {
    position: 'relative',
    zIndex: 10,
    marginBottom: '22px',
  },
  rulesBtn: {
    width: '50px',
    minWidth: '50px',
    height: '50px',
    zIndex: 10,
  },
  rulesIcon: {
    width: '50px',
    height: '50px',
  },
  rulesIconTextWrapper: {
    backgroundColor: 'white',
    position: 'absolute',
    borderRadius: '14px',
    top: '-6px',
    zIndex: 1,
    width: '50px',
    height: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rulesIconText: {
    fontSize: '10px',
    fontWeight: '600',
    letterSpacing: '0.1px',
    color: theme.palette.primary.dark,
    textTransform: 'none',
  },
  topButtonsWrapper: {
    position: 'absolute',
    top: '71px',
    right: '18px',
  },
};
